import styled from 'styled-components';
import { minWidth } from 'helpers/buildMediaQueries';
import { colorsVariables } from '@trustedshops/tps-seo-shared-frontend-react-components';

export const Divider = styled.hr`
  border-style: solid;
  border-width: 2px;
  border-color: ${colorsVariables.BLUE_500};
  border-radius: 3.5px;
  max-width: 100px;
  margin-top: 35px;
  ${minWidth('md', 'max-width: 396px;')}
  ${minWidth('xl', 'margin-top: 50px;')}
  margin-bottom: 0;
`;
